import { graphql } from 'msw';

import { hasValidToken } from '../utils';

export const listGapAnalysisPeriodSelections = graphql.query<
    ListGapAnalysisPeriodSelectionsQuery,
    ListGapAnalysisPeriodSelectionsQueryVariables
>('listGapAnalysisPeriodSelections', (req, res, ctx) => {
    if (hasValidToken(req, 'publisher')) {
        return res(
            ctx.data({
                listGapAnalysisPeriodSelections: [
                    {
                        detection_data_end: null,
                        detection_data_start: null,
                        order: 1,
                        performance_period_end: '2021-03-31',
                        performance_period_label: '2021 Q1',
                        performance_period_start: '2021-01-01',
                        pro_statement_period_label: {
                            end_date: '2021-03-31',
                            pro: 'ASCAP' as GapProName,
                            start_date: '2021-01-01',
                            statement_period_label: '2021 Q3',
                            __typename: 'gapProStatementPeriodLabel',
                        },
                        pro_statement_present: false,
                        __typename: 'gapAnalysisPeriodSelection',
                    },
                    {
                        detection_data_end: null,
                        detection_data_start: null,
                        order: 2,
                        performance_period_end: '2020-12-31',
                        performance_period_label: '2020 Q4',
                        performance_period_start: '2020-10-01',
                        pro_statement_period_label: {
                            end_date: '2020-12-31',
                            pro: 'ASCAP' as GapProName,
                            start_date: '2020-10-01',
                            statement_period_label: '2021 Q2',
                            __typename: 'gapProStatementPeriodLabel',
                        },
                        pro_statement_present: false,
                        __typename: 'gapAnalysisPeriodSelection',
                    },
                    {
                        detection_data_end: '2020-09-30',
                        detection_data_start: '2020-07-01',
                        order: 3,
                        performance_period_end: '2020-09-30',
                        performance_period_label: '2020 Q3',
                        performance_period_start: '2020-07-01',
                        pro_statement_period_label: {
                            end_date: '2020-09-30',
                            pro: 'ASCAP' as GapProName,
                            start_date: '2020-07-01',
                            statement_period_label: '2021 Q1',
                            __typename: 'gapProStatementPeriodLabel',
                        },
                        pro_statement_present: false,
                        __typename: 'gapAnalysisPeriodSelection',
                    },
                    {
                        detection_data_end: '2020-06-30',
                        detection_data_start: '2020-04-01',
                        order: 4,
                        performance_period_end: '2020-06-30',
                        performance_period_label: '2020 Q2',
                        performance_period_start: '2020-04-01',
                        pro_statement_period_label: {
                            end_date: '2020-06-30',
                            pro: 'ASCAP' as GapProName,
                            start_date: '2020-04-01',
                            statement_period_label: '2020 Q4',
                            __typename: 'gapProStatementPeriodLabel',
                        },
                        pro_statement_present: false,
                        __typename: 'gapAnalysisPeriodSelection',
                    },
                    {
                        detection_data_end: '2020-03-31',
                        detection_data_start: '2020-01-01',
                        order: 5,
                        performance_period_end: '2020-03-31',
                        performance_period_label: '2020 Q1',
                        performance_period_start: '2020-01-01',
                        pro_statement_period_label: {
                            end_date: '2020-03-31',
                            pro: 'ASCAP' as GapProName,
                            start_date: '2020-01-01',
                            statement_period_label: '2020 Q3',
                            __typename: 'gapProStatementPeriodLabel',
                        },
                        pro_statement_present: true,
                        __typename: 'gapAnalysisPeriodSelection',
                    },
                    {
                        detection_data_end: null,
                        detection_data_start: null,
                        order: 6,
                        performance_period_end: '2019-12-31',
                        performance_period_label: '2019 Q4',
                        performance_period_start: '2019-10-01',
                        pro_statement_period_label: {
                            end_date: '2019-12-31',
                            pro: 'ASCAP' as GapProName,
                            start_date: '2019-10-01',
                            statement_period_label: '2020 Q2',
                            __typename: 'gapProStatementPeriodLabel',
                        },
                        pro_statement_present: true,
                        __typename: 'gapAnalysisPeriodSelection',
                    },
                    {
                        detection_data_end: null,
                        detection_data_start: null,
                        order: 7,
                        performance_period_end: '2019-09-30',
                        performance_period_label: '2019 Q3',
                        performance_period_start: '2019-07-01',
                        pro_statement_period_label: {
                            end_date: '2019-09-30',
                            pro: 'ASCAP' as GapProName,
                            start_date: '2019-07-01',
                            statement_period_label: '2020 Q1',
                            __typename: 'gapProStatementPeriodLabel',
                        },
                        pro_statement_present: true,
                        __typename: 'gapAnalysisPeriodSelection',
                    },
                    {
                        detection_data_end: null,
                        detection_data_start: null,
                        order: 8,
                        performance_period_end: '2019-06-30',
                        performance_period_label: '2019 Q2',
                        performance_period_start: '2019-04-01',
                        pro_statement_period_label: {
                            end_date: '2019-06-30',
                            pro: 'ASCAP' as GapProName,
                            start_date: '2019-04-01',
                            statement_period_label: '2019 Q4',
                            __typename: 'gapProStatementPeriodLabel',
                        },
                        pro_statement_present: false,
                        __typename: 'gapAnalysisPeriodSelection',
                    },
                ],
            }),
        );
    }

    return res();
});
